import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@material-ui/core';
import React, { useState } from 'react';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

const ResendEmailModal = ({ initialEmail, onResent, showModal, MODAL_TYPE }) => {
    const [email, setEmail] = useState(initialEmail.to);
    const { notifySuccess, notifyError } = useNotify();
    return (
        <form>
            <Dialog
                aria-labelledby="client-modal"
                open
                maxWidth="md"
                onClose={() => showModal(MODAL_TYPE.NONE)}
            >
                <DialogTitle>Resend email</DialogTitle>
                <DialogContent>
                    <form
                        id="newticket-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            doSwaggerCall('emaillogs', 'resendEmail', {
                                emailLogId: initialEmail.id,
                                resendInfo: {
                                    to: email
                                }
                            })
                                .then(() => {
                                    showModal(MODAL_TYPE.NONE);
                                    notifySuccess('Email resent successfully');
                                    onResent?.();
                                })
                                .catch(err => {
                                    console.log(err);
                                    notifyError('Could not resend email');
                                });
                        }}
                    >
                        <TextField
                            label="Email address"
                            value={email}
                            onChange={ev => setEmail(ev.target.value)}
                        />
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!email}
                        type="submit"
                        form="newticket-form"
                    >
                        Resend email
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
};

export default ResendEmailModal;
